/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { location } from './location';
import type { version_games } from './version_games';
export type user_preference = {
  id: string;
  email: string;
  name: string;
  game: version_games;
  builder_interface: user_preference.builder_interface;
  use_latest_version: boolean;
  default_locale: user_preference.default_locale;
  is_guest: boolean;
  location: location | null;
};
export namespace user_preference {
  export enum builder_interface {
    CLASSIC = 'classic',
    OLD_SKOOL = 'oldSkool',
  }
  export enum default_locale {
    EN = 'en',
    FR = 'fr',
    DE = 'de',
    PL = 'pl',
    ES = 'es',
    IT = 'it',
  }
}
